import * as React from 'react';

import * as styles from './DistrictsMap.css';

const DistrictsMapComponent: React.ForwardRefRenderFunction<HTMLDivElement> = (_, ref) => {
  return <div ref={ref} className={styles['map']} />;
};

export const DistrictsMap = React.forwardRef<HTMLDivElement>(DistrictsMapComponent);
